import lzwCompress from 'lzwcompress'
import { ArpeggiCompositionV5 } from '../../types'
import { compressSnapshot, decompressSnapshot } from './CompressionUtils'

export const CURRENT_SONG_VERSION = 6

/*
 * Processes the given stem or song snapshot for storage in a database or localstorage.
 *
 * Latest Version:
 * {
 *  version: 5,
 *  compressedSnapshot: (gzip compressed stringified snapshot, 8-bit number array)
 * }
 *
 * Previous Versions:
 * {
 *  version: 2-4,
 *  compressedSnapshot: (lzw compressed stringified snapshot, 12 bit number array)
 * }
 */
export const serializeSongSnapshot = (snapshot: any): ArpeggiCompositionV5 => {
  return {
    version: CURRENT_SONG_VERSION,
    compressedSnapshot: compressSnapshot(snapshot)
  }
}

/** Returns a snapshot from the serialized song. */
export const deserializeSongSnapshot = (serializedSong: any) => {
  // First, parse if necessary.
  let parsedSong = typeof serializedSong === 'string' ? JSON.parse(serializedSong) : serializedSong
  // Then check the version, and apply correct decompression.
  if (parsedSong.compressedSnapshot) {
    if (parsedSong.version <= 4) {
      // Legacy decompression
      parsedSong = lzwCompress.unpack(parsedSong.compressedSnapshot)
    } else if (parsedSong.version <= 6) {
      parsedSong = decompressSnapshot(parsedSong.compressedSnapshot)
    }
  }
  return parsedSong
}
